import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import TrustedCard from './TrustedCard';

class Results extends React.Component {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    openUserInfo: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    const { results, openUserInfo } = this.props;
    return (
      <Col md="6">
        <Card>
          <CardBody>
            <h3 className="bold-text mb-20">{results.length} résultat{results.length > 1 && 's'} :</h3>
            {
              results.map(item => (
                <TrustedCard key={item._id} item={item} openUserInfo={openUserInfo} />
              ))
            }
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default Results;
